import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from '../home/components/Footer';

export default function SellTradePage() {
  const [formData, setFormData] = useState({
    vehicle: '',
    mileage: '',
    condition: '',
    vin: '',
    licensePlate: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    zipCode: '',
    additionalInfo: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Trade-in valuation:', formData);
    // Handle form submission
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-b from-[#1E293B] to-[#334155] pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-block bg-white/10 backdrop-blur-sm text-white px-4 py-1.5 rounded-full text-xs font-medium mb-4">
              Sell or Trade Your Vehicle
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Get <span className="text-[#10B981] italic">Top Dollar</span> for Your Car
            </h1>
            <p className="text-lg text-gray-300 mb-8">
              Free instant valuation. We buy cars even if you don't buy from us. Same-day payment available.
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#2563EB]/10 rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-3xl text-[#2563EB]"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Best Prices</h3>
              <p className="text-sm text-gray-600">Competitive offers based on current market value</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#10B981]/10 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-[#10B981]"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Quick Process</h3>
              <p className="text-sm text-gray-600">Get your offer in minutes, not days</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#2563EB]/10 rounded-full mx-auto mb-4">
                <i className="ri-truck-line text-3xl text-[#2563EB]"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Free Pickup</h3>
              <p className="text-sm text-gray-600">We come to you at no extra cost</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-[#10B981]/10 rounded-full mx-auto mb-4">
                <i className="ri-checkbox-circle-line text-3xl text-[#10B981]"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No Obligation</h3>
              <p className="text-sm text-gray-600">Free valuation with zero commitment</p>
            </div>
          </div>
        </div>
      </section>

      {/* Valuation Form Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Get Your Free Valuation
            </h2>
            <p className="text-lg text-gray-600">
              Fill out the form below and we'll get back to you with a competitive offer
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-[#F8F9FA] rounded-3xl p-8">
            {/* Vehicle Information */}
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-car-line text-[#2563EB]"></i>
                Vehicle Information
              </h3>
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB]/10 rounded-lg flex-shrink-0">
                    <i className="ri-car-line text-xl text-[#2563EB]"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Year, Make & Model (e.g., 2020 Honda Accord)"
                    value={formData.vehicle}
                    onChange={(e) => setFormData({...formData, vehicle: e.target.value})}
                    className="flex-1 bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB]/10 rounded-lg flex-shrink-0">
                    <i className="ri-dashboard-line text-xl text-[#2563EB]"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="Mileage (e.g., 45,000)"
                    value={formData.mileage}
                    onChange={(e) => setFormData({...formData, mileage: e.target.value})}
                    className="flex-1 bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB]/10 rounded-lg flex-shrink-0">
                    <i className="ri-star-line text-xl text-[#2563EB]"></i>
                  </div>
                  <select
                    value={formData.condition}
                    onChange={(e) => setFormData({...formData, condition: e.target.value})}
                    className="flex-1 bg-transparent border-none outline-none text-gray-900 cursor-pointer"
                    required
                  >
                    <option value="">Select Condition</option>
                    <option value="excellent">Excellent - Like new, no visible wear</option>
                    <option value="good">Good - Minor wear, well maintained</option>
                    <option value="fair">Fair - Some wear, needs minor repairs</option>
                    <option value="poor">Poor - Significant wear, needs repairs</option>
                  </select>
                </div>

                <div className="bg-white rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB]/10 rounded-lg flex-shrink-0">
                    <i className="ri-barcode-line text-xl text-[#2563EB]"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="VIN (Vehicle Identification Number)"
                    value={formData.vin}
                    onChange={(e) => setFormData({...formData, vin: e.target.value})}
                    maxLength={17}
                    className="flex-1 bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                  />
                </div>

                <div className="bg-white rounded-xl p-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#2563EB]/10 rounded-lg flex-shrink-0">
                    <i className="ri-bank-card-line text-xl text-[#2563EB]"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="License Plate Number"
                    value={formData.licensePlate}
                    onChange={(e) => setFormData({...formData, licensePlate: e.target.value})}
                    className="flex-1 bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                  />
                </div>
              </div>
            </div>

            {/* Contact Information */}
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-user-line text-[#2563EB]"></i>
                Contact Information
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white rounded-xl p-4">
                  <input
                    type="text"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                    className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4">
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                    className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4">
                  <input
                    type="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4">
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>

                <div className="bg-white rounded-xl p-4 md:col-span-2">
                  <input
                    type="text"
                    placeholder="ZIP Code"
                    value={formData.zipCode}
                    onChange={(e) => setFormData({...formData, zipCode: e.target.value})}
                    className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-file-text-line text-[#2563EB]"></i>
                Additional Information (Optional)
              </h3>
              <div className="bg-white rounded-xl p-4">
                <textarea
                  placeholder="Tell us more about your vehicle (accidents, modifications, service history, etc.)"
                  value={formData.additionalInfo}
                  onChange={(e) => setFormData({...formData, additionalInfo: e.target.value})}
                  className="w-full bg-transparent border-none outline-none text-gray-900 placeholder-gray-400 resize-none"
                  rows={4}
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-4 bg-[#2563EB] text-white rounded-xl font-semibold hover:bg-[#1d4ed8] transition-colors text-lg whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-send-plane-fill text-xl"></i>
              Get My Free Offer
            </button>

            <p className="text-xs text-gray-500 text-center mt-4">
              By submitting this form, you agree to be contacted about your vehicle valuation
            </p>
          </form>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              How It Works
            </h2>
            <p className="text-lg text-gray-600">
              Simple, fast, and transparent process
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="relative">
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center bg-[#2563EB] text-white rounded-full mx-auto mb-4 text-2xl font-bold">
                  1
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Submit Details</h3>
                <p className="text-sm text-gray-600">Fill out the form with your vehicle information</p>
              </div>
              <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-right-line text-2xl text-gray-300"></i>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center bg-[#10B981] text-white rounded-full mx-auto mb-4 text-2xl font-bold">
                  2
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Get Your Offer</h3>
                <p className="text-sm text-gray-600">Receive a competitive offer within 24 hours</p>
              </div>
              <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-right-line text-2xl text-gray-300"></i>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center bg-[#2563EB] text-white rounded-full mx-auto mb-4 text-2xl font-bold">
                  3
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Schedule Pickup</h3>
                <p className="text-sm text-gray-600">Choose a convenient time for vehicle inspection</p>
              </div>
              <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-right-line text-2xl text-gray-300"></i>
              </div>
            </div>

            <div>
              <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
                <div className="w-16 h-16 flex items-center justify-center bg-[#10B981] text-white rounded-full mx-auto mb-4 text-2xl font-bold">
                  4
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Get Paid</h3>
                <p className="text-sm text-gray-600">Receive payment on the spot or same day</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4">
            <div className="bg-[#F8F9FA] rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-question-line text-[#2563EB]"></i>
                Do I need to buy a car from you to sell mine?
              </h3>
              <p className="text-gray-600 ml-8">
                No! We buy cars even if you don't purchase from us. Our offer stands regardless of whether you're trading in or selling outright.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-question-line text-[#2563EB]"></i>
                How long is my offer valid?
              </h3>
              <p className="text-gray-600 ml-8">
                Your offer is typically valid for 7 days. Market conditions can change, so we recommend acting quickly to lock in your price.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-question-line text-[#2563EB]"></i>
                What if I still owe money on my car?
              </h3>
              <p className="text-gray-600 ml-8">
                No problem! We can work with your lender to pay off your loan directly. If your car is worth more than you owe, you'll receive the difference.
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-xl p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <i className="ri-question-line text-[#2563EB]"></i>
                What documents do I need?
              </h3>
              <p className="text-gray-600 ml-8">
                You'll need your vehicle title, valid ID, and any loan payoff information if applicable. We'll guide you through the entire process.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
